import components from './components'
import constant from './const'
export default {
  components,
  constant,
}
